"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import type { Service } from "@/features/services/constants/services-data";
interface ServiceSituationsSectionProps {
  service: Service;
}
export function ServiceSituationsSection(t0) {
  const $ = _c(15);
  const {
    service
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 20
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    t3 = {
      once: true,
      margin: "-100px"
    };
    t4 = {
      duration: 0.7,
      ease: "easeOut"
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="mb-3 block text-xs font-semibold tracking-[0.2em] text-primary uppercase">Does This Sound Familiar?</span>;
    t6 = <h2 className="font-heading text-[2.5rem] leading-[1.1] font-bold tracking-tight text-foreground sm:text-[3.2rem]">Recognise Where You Are Right Now</h2>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== service.seasonsIntro) {
    t7 = <motion.div initial={t1} whileInView={t2} viewport={t3} transition={t4} className="mx-auto max-w-3xl text-center">{t5}{t6}<p className="mt-6 text-base leading-relaxed font-light text-muted-foreground sm:text-lg">{service.seasonsIntro}</p></motion.div>;
    $[6] = service.seasonsIntro;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== service.situations) {
    t8 = service.situations.map(_temp);
    $[8] = service.situations;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t8) {
    t9 = <div className="mt-16 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">{t8}</div>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t7 || $[13] !== t9) {
    t10 = <section className="relative bg-background py-24 sm:py-32"><div className="mx-auto max-w-6xl px-6 sm:px-10 lg:px-12">{t7}{t9}</div></section>;
    $[12] = t7;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
}
function _temp(situation, idx) {
  return <motion.div key={situation} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: "-50px"
  }} transition={{
    duration: 0.5,
    delay: idx * 0.06
  }} className="group flex items-start gap-3 rounded-2xl border border-border bg-card p-6 shadow-[0_4px_20px_rgba(0,0,0,0.02)] transition-all duration-300 hover:-translate-y-0.5 hover:border-primary/30 hover:shadow-[0_12px_32px_rgba(0,0,0,0.04)]"><span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary transition-colors duration-300 group-hover:bg-primary group-hover:text-primary-foreground"><Check className="h-3.5 w-3.5" strokeWidth={2.5} /></span><p className="text-[15px] leading-relaxed font-medium text-foreground">{situation}</p></motion.div>;
}